import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { polygon as viemPolygon } from 'viem/chains'

import type { AppChain } from './chain.types'

export const polygon = viemDefineChain({ ...viemPolygon, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Polygon PoS',
    shortName: 'Polygon',
    safeShortName: 'matic',
    morphoChainSlug: 'polygon',
    defiLlamaSlug: 'polygon',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://polygonscan.com', name: 'Polygonscan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0xe675A2161D4a6E2de2eeD70ac98EEBf257FBF0B0',
          startBlock: 66931042n
        },
        MorphoBlue: {
          address: '0x1bF0c2541F820E775182832f06c0B7Fc27A25f67',
          startBlock: 66931042n
        },
        MetaMorphoV11Factory: {
          address: '0xa9c87daB340631C34BB738625C70499e29ddDC98',
          startBlock: 66931118n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0xC11a53eE9B1eCc7a068D8e40F8F17926584F97Cf',
          startBlock: 77371907n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0xD1A0C86F28ecD1657Ad06415c2B230cC89D9b6dd',
          startBlock: 77371907n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xc0006f52B38625C283dd2f972dD9B779A5851Dd0',
          startBlock: 80128162n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xEb174FEA51Da241eB3B516959B216e013de2888a',
          startBlock: 77371907n
        },
        RegistryList: {
          address: '0xb70a43821d2707fA9d0EDd9511CC499F468Ba564',
          startBlock: 77372020n
        },
        BluePublicAllocator: {
          address: '0xAb06a92cd253Bc12Dec8f719a693a6b472CCDfF4',
          startBlock: 92141509n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
